import React from 'react'

export default function(props) {
    const { children } = props

    return (
        <div className="modal-button-strip">
            { children }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Shared/ModalButtonStrip.jsx